<template lang="pug">
  .courator-assing
    h4.mb-1
      v-tooltip(top)
        template(#activator="{ on }")
          v-icon(v-on="on" color="warning" size="28").mr-2.pb-1 mdi-alert-circle-outline
        span Если нет куратора, то некому будет отвечать
          |  на консультации курса и в telegram чате курса
      span Привязка куратора
    p.grey--text Выберите одного/несколько преподавателей ниже из списка
    server-data(
      ref="serverData"
      v-bind="serverDataAttrs"
      v-slot="{ serverData, selectProps, loadMoreItems, search }"
      searchFieldName="search[name]"
      :method="$api.teachers.index"
    )
      v-autocomplete-more(
        v-model="teachers.selected"
        v-bind="selectProps"
        item-text="full_name"
        item-value="user_id"
        color="secondary"
        multiple
        rounded
        small-chips
        cache-items
        hide-details
        outlined
        deletable-chips
        label="Выберите одного или несколько"
        :disabled="teachers.loading"
        :loading="teachers.loading"
        large
        @update:search-input="search"
        @load-more-items="$refs.serverData.loadMoreItems"
        @change="assignTeachers"
      )
    //- select-teacher(
    //-   v-model="teachers.selected"
    //-   :server-data-attrs="serverDataAttrs"
    //-   color="secondary"
    //-   multiple
    //-   small-chips
    //-   hide-details
    //-   outlined
    //-   deletable-chips
    //-   placeholder="Выберите одного или несколько"
    //-   :disabled="teachers.loading"
    //-   :loading="teachers.loading"
    //-   large
    //-   @change="assignTeachers"
    //- )
</template>

<script>
import _ from 'lodash';

import SelectTeacher from '@/components/InputFields/teacher/SelectTeacher.vue';

export default {
  components: {
    SelectTeacher,
  },
  props: {
    courseId: { type: Number, required: true },
  },
  data: () => ({
    teachers: {
      loading: false,
      assigned: null,
      selected: null,
    },
    initialQuery: null,
  }),
  computed: {
    serverDataAttrs() {
      return {
        query: {
          'search[organization]': this.$user.organization && this.$user.organization.id,
          ...this.initialQuery,
        },
      };
    },
  },
  watch: {
    'teachers.selected': function (val) {
      this.initialQuery = {
        'search[user_id]': val,
      };
      setTimeout(() => {
        this.initialQuery = {};
      }, 1000);
    },
  },
  created() {
    this.fetchCourators();
  },
  methods: {
    async fetchCourators() {
      const { items } = await this.$api.users.index({
        'search[curator_course_id]': this.courseId,
      });
      this.teachers.assigned = items.map((i) => i.id);
      this.teachers.selected = items.map((i) => i.id);
    },
    async assignTeachers() {
      this.teachers.loading = true;
      let userIds;
      let strategy;
      if (this.teachers.selected.length < this.teachers.assigned.length) {
        strategy = 'detachCourators';
        userIds = _.difference(this.teachers.assigned, this.teachers.selected);
      } else {
        strategy = 'attachCourators';
        userIds = _.difference(this.teachers.selected, this.teachers.assigned);
      }
      await this.$api.teachers[strategy](this.courseId, {
        user_ids: userIds,
      });
      this.teachers.assigned = [...this.teachers.selected];
      this.teachers.loading = false;
    },
  },
};
</script>
